export const getCssVars = (values, suffix) => {
  if (values && values.length > 0) {
    const cssValues = values.split(',');
    if (cssValues.length) {
      const xlValue = cssValues[0];
      const lgValue = cssValues[1] || xlValue;
      const mdValue = cssValues[2] || lgValue;
      const smValue = cssValues[3] || mdValue;

      return {
        [`--xl-${suffix}`]: xlValue,
        [`--lg-${suffix}`]: lgValue,
        [`--md-${suffix}`]: mdValue,
        [`--sm-${suffix}`]: smValue,
      };
    }
    return null;
  }
  return null;
};
